import {
  Typography,
  Tooltip
} from '@material-tailwind/react'
import PropTypes from 'prop-types'
import { IoMdHelpCircleOutline } from 'react-icons/io'
import { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Box } from '@/shared/components/box'
import { colors } from '../../utils/colors'

export const DashboardBigCard = ({
  title,
  subtitle,
  value,
  footerDescription,
  tooltipTitle,
  tooltipDescription
}) => {
  const tooltipRef = useRef()
  const { t } = useTranslation()

  const getRiskColor = (value) => {
    if (value === 100) return 'blue'
    if (value >= 75) return 'green'
    if (value >= 40) return 'yellow'

    return 'red' // Red
  }

  const riskColor = getRiskColor(value)
  const borderColor = colors[riskColor][500]
  const backgroundColor = colors[riskColor][50]

  return (
    <Box style={{ backgroundColor, borderColor }} className='flex flex-col justify-between'>
      <div className="flex flex-row gap-3 mb-3">
        <Typography className="text-sm font-semibold">{title}</Typography>
        <Tooltip
          ref={tooltipRef}
          className="bg-blue-600"
          placement="top-start"
          content={
            <div className="w-80">
              <Typography className="font-medium">{tooltipTitle}</Typography>
              <Typography
                variant="small"
                color="white"
                className="font-normal opacity-80"
              >
                {tooltipDescription}
              </Typography>
            </div>
          }
        >
          <div ref={tooltipRef}>
            <IoMdHelpCircleOutline className="text-xl text-gray-400" />
          </div>
        </Tooltip>
      </div>
      <div className='flex justify-between'>
        <Typography className="text-black text-3xl font-semibold">
          {value}%
        </Typography>
      </div>
    </Box>
  )
}

DashboardBigCard.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  footerDescription: PropTypes.string.isRequired,
  tooltipTitle: PropTypes.string.isRequired,
  tooltipDescription: PropTypes.string.isRequired
}

DashboardBigCard.defaultProps = {
  title: '',
  subtitle: '',
  value: '',
  footerDescription: '',
  tooltipTitle: '',
  tooltipDescription: ''
}
